import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl,FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient} from '@angular/common/http'
import { ApiService } from '../api.service';
import {Country,Event,EventYacht,EventCrew,EventClass,User } from "../database";  // Classi per ogni tabella database
import { TranslateService } from '../translate.service';
// import { userInfo } from 'os';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {

  newUserFailed: boolean;
  newUserDuplicate: boolean;
  passwordMatchFailed: boolean;
  passwordMatchText : string;

  countries: Country[];
  user: User;
  login: string;  
  password: string;
  
  // I FormControl sono raggruppati in FormGroup (uno per ogni step)
  // e aggiunti ad un FormArray per aiutare l'elaborazione.
  formArray1: FormArray;
  formGroup1: FormGroup;

  constructor(private router: Router, private formBuilder: FormBuilder, private http: HttpClient,
              public api:ApiService,public translate: TranslateService) { }

  ngOnInit() {

    console.log("UserComponent.this.api.id_user = " + this.api.id_user);
    console.log("UserComponent.this.api.id_eventyacht = " + this.api.id_eventyacht);

    this.createForms();
    this.reloadForms();
    
    // Inzializzo variable che indica eventuale errore nella creazione nuovo utente
    this.newUserFailed = false;
    this.newUserDuplicate = false;
    this.passwordMatchFailed = false;
    this.passwordMatchText = "";

  }  
  
  createForms(){
    // Creazione oggetti per la gestione reactive Forms
    this.formGroup1 = this.formBuilder.group({
      name: ['', Validators.required],
      surname: ['', Validators.required],
      fiscalcode: [''],
      company: [''],
      birthplace: [''],
      birthdate: [''],
      addrs1: ['', Validators.required],
      addrs2: [''],
      cap: [''],
      city: ['', Validators.required],
      id_country: [''],
      // country: [''],
      tel1: ['', Validators.required],
      tel2: [''],
      mobile: ['', Validators.required],
      fax: [''],
      email: ['', [Validators.required,Validators.email]],
      website: [''],
      password: ['', [Validators.required,Validators.minLength(4)]],
      });

      this.formArray1 = new FormArray([]);
      this.formArray1.push(this.formGroup1);
  }  

  setFormDefaults(){
    
    // Se utente registrato mostro i dati utente
    if (this.api.id_user>0)
    {
      // Imposta i valori del form leggendoli dall'iscrizione 
      this.formGroup1.controls['name'].setValue(this.user.name);
      this.formGroup1.controls['surname'].setValue(this.user.surname);
      this.formGroup1.controls['fiscalcode'].setValue(this.user.fiscalcode);
      this.formGroup1.controls['company'].setValue(this.user.company);
      this.formGroup1.controls['birthplace'].setValue(this.user.birthplace);
      this.formGroup1.controls['birthdate'].setValue(this.user.birthdate);
      this.formGroup1.controls['addrs1'].setValue(this.user.addrs1);
      this.formGroup1.controls['addrs2'].setValue(this.user.addrs2);
      this.formGroup1.controls['cap'].setValue(this.user.cap);
      this.formGroup1.controls['city'].setValue(this.user.city);
      this.formGroup1.controls['id_country'].setValue(this.user.id_country);
      this.formGroup1.controls['tel1'].setValue(this.user.tel1);
      this.formGroup1.controls['tel2'].setValue(this.user.tel2);
      this.formGroup1.controls['mobile'].setValue(this.user.mobile);
      this.formGroup1.controls['fax'].setValue(this.user.fax);
      this.formGroup1.controls['email'].setValue(this.user.email);
      this.formGroup1.controls['website'].setValue(this.user.website);
      this.formGroup1.controls['password'].setValue(this.user.password);

      this.passwordMatchText = this.user.password;
    }
  }  

  reloadForms(){
    // Provo a mettere in unica funzione la rilettura forms da database
    this.api.call({
      "id": "",
      "auth": "", // ATTENZIONE, solo per risorsa countries viene ignorato auth
      "resource": "countries",
      "action": "GET",
      "offset": 0,
      "limit": 0,
      "filters": [],
      "order": "",
      "data": []
    }).subscribe((dataCountries: any[]) => {
      this.countries = dataCountries['data'];
      // console.log("N." + this.countries.length + " countries loaded");

      // La nazionalità serve sempre mentre carico dati utente solo in caso di utente esistente
      // che ha fatto il login.
      if (this.api.id_user > 0)
      {
        this.api.call({
          "id": "",
          "auth": "this.api.authData.sid",
          "resource": "users",
          "action": "GET",
          "offset": 0,
          "limit": 0,
          "filters": ["id_user=" + this.api.id_user],
          "order": "",
          "data": []
        }).subscribe((dataUsers: any[]) => {

          if (dataUsers['data'].length>0)
          {
            this.user = dataUsers['data'][0];
            console.log("UserComponent::user loaded, name = " + this.user.name);
            this.setFormDefaults();
          }
        });
      }  
    });
  }

  saveNewUser(){
    // Salvo i dati Form in una nuova iscrizione
    
    // Controllo che i dati iscrizione siano almeno completi
    if (this.formGroup1.valid == false)
    {
      this.newUserFailed = true;
      this.newUserDuplicate = false;
      this.passwordMatchFailed = false;
    }
    else if (this.formGroup1.controls['password'].value!=this.passwordMatchText)
    {
      console.log("Password Match failed!!");
      console.log("this.formGroup1.controls['password'].value="+this.formGroup1.controls['password'].value);
      console.log("this.passwordMatchText="+this.passwordMatchText);
      this.newUserFailed = false;
      this.newUserDuplicate = false;
      this.passwordMatchFailed = true;
    } 
    else
    {    
    
      // Costruisco oggetto contenente coppie chiave/valore per tutti i FormControl
      // non nulli contenuti nel FormArray passato a parametro
      this.newUserFailed = false;
      this.passwordMatchFailed = false;
      this.login = this.formGroup1.controls['email'].value;
      this.password = this.formGroup1.controls['password'].value;

      // TODO Devo controllare presenza di duplicato "email"
      this.api.call({
          "id": "",
          "auth": "",
          "resource": "users",
          "action": "GET",
          "offset": 0,
          "limit": 0,
          // ATTENZIONE, le email contengono caratteri @ non stampabili, devo usare parentesi
          "filters": ["email='" + this.login+"'"],
          "order": "",
          "data": []
        }).subscribe((data: any[]) => {
          if (data['data'].length>0) {
            this.newUserDuplicate = true;
            console.log("this.newUserDuplicate = " + this.newUserDuplicate);
          }
          else
          {
            // Nuovo utente, non duplicato, procedo al salvataggio
            this.newUserDuplicate = false;
            console.log("this.newUserDuplicate = " + this.newUserDuplicate);
            var newUserData = this.api.formArrayToApiData(this.formArray1);
            this.api.call({
              "id": "",
              "auth": "",
              "resource": "users",
              "action": "POST",
              "offset": 0,
              "limit": 0,
              "filters": [],
              "order": "",
              "data": newUserData
            }).subscribe((data: any[]) => {
              console.log("saveUser::api reply = " + data['data']);
              // Per agevolare l'utente provo a fare login con le ultime credenziali inserite
              // Se ho successo invio email di conferma
              this.api.login(this.login,this.password).subscribe((data:any[]) => {
                if (data['data'].id_user>0)
                {
                  this.api.authData = data['data'];
                  this.api.id_user = this.api.authData.id_user;
                  this.api.id_eventyacht = -1;
                  this.api.id_event = -1;
                  this.api.event_name = "";
                  this.api.email = this.login;
                  console.log("saveNewUser call to api.log returned with : sid=" + this.api.authData.sid);
                  console.log("saveNewUser call to api.log returned with : name=" + this.api.authData.name);
                  console.log("saveNewUser call to api.log returned with : this.api.id_user=" + this.api.id_user);
                  console.log("saveNewUser call to api.log returned with : this.api.email=" + this.api.email);
                  
                  // Invio email di conferma al nuovo utente registrato e connesso
                  const fd = new FormData();
                  fd.append('SendNewUserMail',this.api.id_user.toString());
                  this.http.post('api/sendmail.php',fd).subscribe((data: any) => {
                      console.log(data);
                      // Per ultimo attivo la pagina principale
                      this.router.navigate(['/events']);
                  }); 
                }
                else
                {
                  console.log("saveNewUser call to api.log returned with error data['data'].id_user=" + data['data'].id_user);
                }
              }); // Login 
          });
        };  
      });  
    }
  }    

  saveUpdatedUser(){
    // Aggiorno l'iscrizione esistente con i dati del Form
    // Costruisco oggetto contenente coppie chiave/valore per tutti i FormControl
    // non nulli contenuti nel FormArray passato a parametro
    console.log("saveUpdatedUser::this.api.id_user="+this.api.id_user);
   
    if (this.formGroup1.valid == false)
    {
      this.newUserFailed = true;
      this.newUserDuplicate = false;
      this.passwordMatchFailed = false;
    }
    else if (this.formGroup1.controls['password'].value!=this.passwordMatchText)
    {
      console.log("Password Match failed!!");
      console.log("this.formGroup1.controls['password'].value="+this.formGroup1.controls['password'].value);
      console.log("this.passwordMatchText="+this.passwordMatchText);
      this.newUserFailed = false;
      this.newUserDuplicate = false;
      this.passwordMatchFailed = true;
    } 
    else
    {    
      // var data = this.formArrayToApiData(this.formArray1);
      var data = this.api.formArrayToApiData(this.formArray1);
      
      // Non sono presenti altri  altri campi da aggiungere a "data" come avviene nel caso di nuova iscrizione
      // Aggiunge nuova iscrizione con chiama api post
      this.api.call({
        "id": "",
        "auth": "",
        "resource": "users",
        "action": "UPDATE",
        "offset": 0,
        "limit": 0,
        "filters": ["id_user=" + this.api.id_user],
        "order": "",
        "data": data
      }).subscribe((data: any[]) => {
        console.log("saveUpdatedUser::api reply = " + data);
        this.router.navigate(['/events']);
      });    
    }  
  }  

  testForm(){
    console.log("UserComponent::Test form")
    console.log("this.formGroup1.dirty=" + this.formGroup1.dirty);
    console.log("this.formGroup1.pristine=" + this.formGroup1.pristine);
    console.log("this.formGroup1.pending=" + this.formGroup1.pending);

  }

  cancelForm() {
    console.log("cancelForm");
    // Se era in corso creazione nuovo utente imposto indice nuovo utente a nessuno e trono a login
    // Se era in corso modifica ad utente esistente (>0) non modifico indice e torno ad eventi
    if (this.api.id_user==0)
    {
      this.api.id_user=-1;
      this.router.navigate(['/login']);
    }
    else if (this.api.id_user>0)
    {
      this.router.navigate(['/events']);
    }  
  }

  onPassowordMatchKeyUp(event:any){
    this.passwordMatchText = event.target.value;
  }

}
